// PROPOSITO: a donde va cada rol al entrar. Un solo sitio lo decide.
// DEPENDENCIAS: src/types/dominio.
// NO OBVIO: vive aparte del Guard para que ese archivo exporte solo componentes y el recambio en
// caliente siga funcionando durante el desarrollo.
import type { Rol } from '@/types/dominio'

export function inicioSegunRol(rol: Rol): string {
  switch (rol) {
    case 'alumna':
      return '/hoy'
    case 'entrenadora':
      return '/panel'
    case 'admin_plataforma':
      return '/plataforma'
  }
}
